import React from 'react';
import { Search, Calendar } from 'lucide-react';

const BookingFilters = ({ 
  searchTerm, 
  setSearchTerm, 
  startDate, 
  setStartDate, 
  endDate, 
  setEndDate, 
  handleDateFilter, 
  handleClearFilters, 
  dateError,
  onPageReset,
  resetSearch
}) => {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:gap-6 flex-wrap">
        
        {/* Search */}
        <div className="relative w-full lg:flex-1">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" />
          <input
            type="text"
            placeholder="Search by patient name, UHID, surgery type, room, etc..."
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value);
              onPageReset?.();
            }}
            className="w-full pl-11 pr-10 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500 outline-none transition-all"
          />
          {searchTerm && (
            <button
              onClick={resetSearch}
              className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
            >
              ✕
            </button>
          )}
        </div>

        <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
          {/* Start Date */}
          <div className="flex-1">
            <label className="block mb-1 text-sm font-medium text-gray-700">Start Date</label>
            <input
              type="date"
              value={startDate}
              min={new Date().toISOString().split("T")[0]}
              onChange={(e) => {
                setStartDate(e.target.value);
                onPageReset?.();
              }}
              className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500 outline-none"
            />
          </div>

          {/* End Date */}
          <div className="flex-1">
            <label className="block mb-1 text-sm font-medium text-gray-700">End Date</label>
            <input
              type="date"
              value={endDate}
              min={startDate || new Date().toISOString().split("T")[0]} 
              onChange={(e) => {
                setEndDate(e.target.value);
                onPageReset?.();
              }}
              className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500 outline-none"
            />
          </div>
        </div>

        <div className="flex gap-3 w-full sm:w-auto flex-wrap">
          <button 
            onClick={handleDateFilter}
            className="w-full sm:w-auto px-4 py-2 border border-gray-200 hover:bg-teal-50 hover:text-teal-600 hover:border-teal-200 rounded-lg transition-colors flex items-center justify-center gap-2"
          >
            <Calendar className="h-5 w-5" />
            Filter by Date
          </button>

          <button
            onClick={handleClearFilters}
            className="w-full sm:w-auto px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
          >
            Clear Filters
          </button>
        </div>
      </div>

      {/* Date Error */}
      {dateError && (
        <div className="mt-4 p-3 bg-red-50 border border-red-200 rounded-lg">
          <p className="text-red-600 text-sm">{dateError}</p>
        </div>
      )}
    </div>
  );
};

export default BookingFilters;
